/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */

export type ImportStatusEnum = typeof ImportStatusEnum[keyof typeof ImportStatusEnum];


export const ImportStatusEnum = {
  CREATED: 'created',
  STARTED: 'started',
  FINISHED: 'finished',
  FAILED: 'failed',
} as const;
